export default (state) => state.notifications;
